// FormUtils.js

import { NumericFormat } from 'react-number-format';
import { confirmDialog } from "primereact/confirmdialog";  
import { Tooltip } from 'primereact/tooltip';

// Função para criar campos de "Sim/Não"
export const renderYesNoField = (formData, handleChange, fieldName, fieldLabel, GetTranslation, iconDescription = null) => (
  <div className="col-md-6">
    <label className="form-label">
      {GetTranslation(fieldLabel)}
      {iconDescription && (
        <>
          <i
            id={`${fieldName}-tooltip`}
            className="bi bi-exclamation-circle ms-2"
            data-pr-tooltip={GetTranslation(iconDescription)}
          ></i>
          <Tooltip target={`#${fieldName}-tooltip`} />
        </>
      )}
    </label>
    
    <p>
      <div className="form-check form-check-inline">
        <input
          className="form-check-input"
          type="radio"
          name={fieldName}
          value="1"
          checked={formData[fieldName] === "1"}
          onChange={handleChange}
        />
        <label className="form-check-label">{GetTranslation("Sim")}</label>
      </div>
      <div className="form-check form-check-inline">
        <input
          className="form-check-input"
          type="radio"
          name={fieldName}
          value="0"
          checked={formData[fieldName] === "0"}
          onChange={handleChange}
        />
        <label className="form-check-label">{GetTranslation("Não")}</label>
      </div>
    </p>
  </div>
);

export const renderNumericField = (formData, setFormData, fieldName, fieldLabel, decimalPlaces, GetTranslation, iconDescription = null) => (
  <div className="col-md-6">
    <label className="form-label">
      {GetTranslation(fieldLabel)}
      {iconDescription && (
        <>
          <i
            id={`${fieldName}-tooltip`}
            className="bi bi-exclamation-circle ms-2"
            data-pr-tooltip={GetTranslation(iconDescription)}
          ></i>
          <Tooltip target={`#${fieldName}-tooltip`} />
        </>
      )}
    </label>

    <NumericFormat
      className="form-control"
      name={fieldName}
      value={formData[fieldName]}
      onValueChange={(values) => {
        const { value } = values; // Retorna o valor numérico sem formatação
        setFormData((prev) => ({
          ...prev,
          [fieldName]: value, // Atualiza o campo específico no formData
        }));
      }}
      decimalSeparator=","
      thousandSeparator="."
      allowNegative={false}
      decimalScale={decimalPlaces} // Define até o número de casas decimais que você deseja
    />
  </div>
);

// Função para criar um grupo de checkboxes
export const renderCheckboxGroup = (formData, handleCheckboxChange, fieldName, fieldLabel, options, GetTranslation, iconDescription = null) => (
  <div className="col-md-6">
    <label className="form-label">
      {GetTranslation(fieldLabel)}
      {iconDescription && (
        <>
          <i
            id={`${fieldName}-tooltip`}
            className="bi bi-exclamation-circle ms-2"
            data-pr-tooltip={GetTranslation(iconDescription)}
          ></i>
          <Tooltip target={`#${fieldName}-tooltip`} />
        </>
      )}
    </label>
    <div className="d-flex flex-wrap">
      {options.map((option) => (
        <div key={option} className="form-check form-check-inline" style={{ marginRight: "10px" }}>
          <input
            type="checkbox"
            className="form-check-input"
            value={option}
            checked={formData[fieldName].includes(option)}
            onChange={(e) => handleCheckboxChange(e, fieldName)}
            id={`${fieldName}-${option}`}  // Adiciona um ID único para cada checkbox
          />
          <label className="form-check-label" htmlFor={`${fieldName}-${option}`}>
            {GetTranslation(option) }
          </label>
        </div>
      ))}
    </div>
  </div>
);

// Função para criar campos de TextArea
export const renderTextAreaField = (formData, handleChange, fieldName, fieldLabel, GetTranslation, iconDescription = null) => (
  <div className="col-md-12">
    <label className="form-label">
      {GetTranslation(fieldLabel)}
      {iconDescription && (
        <>
          <i
            id={`${fieldName}-tooltip`}
            className="bi bi-exclamation-circle ms-2"
            data-pr-tooltip={GetTranslation(iconDescription)}
          ></i>
          <Tooltip target={`#${fieldName}-tooltip`} />
        </>
      )}
    </label>
    <textarea
      className="form-control"
      name={fieldName}
      value={formData[fieldName] || ""}
      onChange={handleChange}
      rows={4}  // Número de linhas do campo de texto
    />
  </div>
);

// Função para criar campos de Input Text
export const renderInputTextField = (formData, handleChange, fieldName, fieldLabel, GetTranslation, iconDescription = null) => (
  <div className="col-md-6">
    <label className="form-label">
      {GetTranslation(fieldLabel)}
      {iconDescription && (
        <>
          <i
            id={`${fieldName}-tooltip`}
            className="bi bi-exclamation-circle ms-2"
            data-pr-tooltip={GetTranslation(iconDescription)}
          ></i>
          <Tooltip target={`#${fieldName}-tooltip`} />
        </>
      )}
    </label>
    <input
      type="text"
      className="form-control"
      name={fieldName}
      value={formData[fieldName] || ""}
      onChange={handleChange}
    />
  </div>
);

export const renderSelectField = (
  formData,
  handleChange,
  fieldName,
  label,
  options,
  GetTranslation,
  iconDescription = null
) => {
  return (
    <div className="col-md-6">
      <label className="form-label">
        {GetTranslation(label)}
        {iconDescription && (
          <>
            <i
              id={`${fieldName}-tooltip`}
              className="bi bi-exclamation-circle ms-2"
              data-pr-tooltip={GetTranslation(iconDescription)}
            ></i>
            <Tooltip target={`#${fieldName}-tooltip`} />
          </>
        )}
      </label>
      <select
        name={fieldName}
        value={formData[fieldName]}
        onChange={handleChange}
        className="form-control"
      >
        {/* Opção "Selecione" */}
        <option value="">{GetTranslation("Selecione")}</option>

        {options.map((option, index) => {
          const translatedOption = GetTranslation(option);
          const displayOption =
            translatedOption === "Tradução não disponível" || !translatedOption
              ? option
              : translatedOption;
          return (
            <option key={index} value={option}>
              {displayOption}
            </option>
          );
        })}
      </select>
    </div>
  );
};

// Função para criar campos numéricos (range)
export const renderRangeField = (formData, setFormData, fieldName, fieldLabel, min, max, decimalPlaces, GetTranslation, iconDescription = null) => (
  <div className="col-md-6">
    <label className="form-label">
      {GetTranslation(fieldLabel)}
      {iconDescription && (
        <>
          <i
            id={`${fieldName}-tooltip`}
            className="bi bi-exclamation-circle ms-2"
            data-pr-tooltip={GetTranslation(iconDescription)}
          ></i>
          <Tooltip target={`#${fieldName}-tooltip`} />
        </>
      )}
    </label>

    <NumericFormat
      className="form-control"
      name={fieldName}
      value={formData[fieldName]}
      onValueChange={(values) => {
        const { value } = values;
        setFormData((prev) => ({
          ...prev,
          [fieldName]: value,
        }));
      }}
      decimalSeparator=","
      thousandSeparator="."
      allowNegative={false}
      decimalScale={decimalPlaces}  // Define as casas decimais permitidas
      min={min}
      max={max}
    />
  </div>
);

export const renderLabelField = (label, value, GetTranslation, iconDescription = null) => {
  return (
    <div className="col-md-6">
      <label className="form-label">
        {GetTranslation(label)}
        {iconDescription && (
          <>
            <i
              id={`${label}-tooltip`}
              className="bi bi-exclamation-circle ms-2"
              data-pr-tooltip={GetTranslation(iconDescription)}
            ></i>
            <Tooltip target={`#${label}-tooltip`} />
          </>
        )}
      </label>
      <p className="form-control-static">
        {value ? parseFloat(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}
      </p>
    </div>
  );
};

// Função para converter campos de "Sim/Não" de números para strings
export const convertYesNoFieldsToString = (data, yesNoFields) => {
  let updatedData = { ...data };

  yesNoFields.forEach((field) => {
    if (data[field] !== undefined && data[field] !== null) {  // Verifica se o valor não é undefined ou null
      updatedData[field] = data[field].toString();  // Converte para string
    }
  });

  return updatedData;
};

// Função para verificar se um campo é diferente de "Selecione", "", null, ou outros valores passados
export const isFieldDifferentFromValues = (formData, fieldName, additionalInvalidValues = []) => {
  const value = formData[fieldName];

  // Verifica se o valor é diferente de "Selecione", "", null e de qualquer valor adicional
  return value !== "Selecione" && value !== "" && value !== undefined && value !== null && !additionalInvalidValues.includes(value);
};


export const convertDateForInput = (dateString) => {
  if (!dateString) return "";

  // Converte a string "Mon, 09 Mar 1992 00:00:00 GMT" em um objeto Date
  const dateObj = new Date(dateString);

  // Extrai o dia, mês e ano usando UTC
  let day = String(dateObj.getUTCDate()).padStart(2, '0');
  let month = String(dateObj.getUTCMonth() + 1).padStart(2, '0'); // Mês é zero-indexado, por isso adicionamos 1
  let year = dateObj.getUTCFullYear();

  // Retorna no formato dd/mm/yyyy
  return `${day}/${month}/${year}`;
};


export const formatDateForBackend = (date) => {
  const [day, month, year] = date.split("/");
  return `${year}-${month}-${day}`;
};

export const formatDecimalForBackend = (value) => {
  return value.replace(',', '.');
};

export const validateFields = (formData, requiredFields, GetTranslation, notify) => {
  const missingFields = [];

  console.log(formData);

  // Itera sobre os campos obrigatórios e verifica se estão vazios ou com o valor "Selecione"
  requiredFields.forEach(field => {
    const fieldValue = formData[field];

    // Verifica se o campo está vazio ou se o valor é "Selecione" (assumido como "")
    if (!fieldValue || fieldValue === "") {
      missingFields.push(GetTranslation(field)); // Adiciona a tradução do campo ao array de campos faltantes
    }
  });

  if (missingFields.length > 0) {
    notify({
      type: "error",
      message: GetTranslation("Os seguintes campos são obrigatórios:") + " " + missingFields.join(", ")
    });
    return false;
  }

  return true;
};

export const handleConfirmSave = (formData, requiredFields, validateFields, GetTranslation, notify, handleSubmit) => {
  return (e) => {
    e.preventDefault();
    
    // Valida os campos antes de exibir o dialog de confirmação
    if (!validateFields(formData, requiredFields, GetTranslation, notify)) return;

    // Exibe o dialog de confirmação
    confirmDialog({
      message: GetTranslation("Confirmar_salvar"),
      header: GetTranslation("Confirmar"),
      icon: "pi pi-exclamation-triangle",
      acceptLabel: GetTranslation("Yes"),
      rejectLabel: GetTranslation("No"),
      accept: handleSubmit,  
      reject: () => {
        notify({
          type: "info",
          message: GetTranslation("Operacao_cancelada")
        });
      }
    });
  };
};

export const handleNavigateBack = (navigate, id) => {
  return () => {
    navigate("/app/categoria/" + id);
  };
};
